export default {
  name: "delete-address-card",
  components: {},
  props: {
    addressData: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialog: false
    };
  },
  computed: {},
  mounted() {},
  methods: {
    handleDialog() {
      this.$emit("confirmDeleteAddr", false, true);
      // this.dialog = true;
    },
    closeDialog() {
      this.$emit("closeDialog");
    }
  }
};
